/* * Version: 3.4.0
 * Letzte Änderung: 18.09.2026, 15:15
 * Änderungshistorie: AuthContext integriert. Bedingter Menüpunkt für Benutzerverwaltung und Logout-Button für eingeloggte Administratoren hinzugefügt. Login-Screen blendet Navigation aus.
 * Copyright: BAIT-Tech
 */
import React, { useContext } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // AuthContext einbinden, um Benutzerinformationen und die Logout-Funktion abzurufen
  const { userInfo, logout } = useContext(AuthContext);

  const pathParts = location.pathname.split('/'); 
  const isTournamentPage = pathParts[1] === 'turnier';
  const tournamentId = isTournamentPage && pathParts[2] ? pathParts[2] : null;

  // Logout-Handler: Beendet die Sitzung und leitet sicher zur Login-Seite weiter
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Wenn wir auf der Login-Seite sind, zeigen wir nur das Branding, keine Navigation
  if (location.pathname === '/login') {
    return (
      <header className="App-header">
        <div className="header-content">
          <h1>SKV-Turnier-Manager</h1>
        </div>
      </header>
    );
  }

  return (
    <header className="App-header">
      <div className="header-content" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <h1>SKV-Turnier-Manager</h1>
        <nav style={{ display: 'flex', alignItems: 'center', flexGrow: 1, justifyContent: 'space-between' }}>
          <div className="main-nav">
            {isTournamentPage && tournamentId ? (
              <ul>
                <li><NavLink to={`/turnier/${tournamentId}`}>Nennungen</NavLink></li>
                <li><NavLink to={`/turnier/${tournamentId}/startplan`}>Startplan/ErgebnisEingabe</NavLink></li>
                <li><NavLink to={`/turnier/${tournamentId}/ergebnisse`}>Ergebnisse</NavLink></li>
                <li><NavLink to={`/turnier/${tournamentId}/statistik`}>Statistik</NavLink></li>
                <li><NavLink to={`/turnier/${tournamentId}/finanzen`}>Finanzen</NavLink></li>
                <li><NavLink to={`/turnier/${tournamentId}/pokale`}>Pokale</NavLink></li>
                <li><NavLink to={`/turnier/${tournamentId}/urkunden`}>Urkunden</NavLink></li>
                <li><NavLink to="/hilfe">Anleitung</NavLink></li>
                <li><NavLink to="/">Alle Turniere</NavLink></li>
              </ul>
            ) : (
              <ul>
                <li><NavLink to="/">Turniere</NavLink></li>
                <li><NavLink to="/vereine">Vereine</NavLink></li>
                <li><NavLink to="/spieler">Spieler</NavLink></li>
                <li><NavLink to="/vorlagen">Vorlagen</NavLink></li>
                <li><NavLink to="/hilfe">Anleitung</NavLink></li>
                {/* Die Benutzerverwaltung wird nur im Hauptmenü angezeigt, wenn der Admin eingeloggt ist */}
                {userInfo && <li><NavLink to="/benutzer">Benutzer</NavLink></li>}
              </ul>
            )}
          </div>
          
          {/* Status-Bereich und Logout-Button für eingeloggte Administratoren */}
          {userInfo && (
            <div className="auth-nav" style={{ marginLeft: '20px', display: 'flex', alignItems: 'center', gap: '15px' }}>
              <span style={{ fontSize: '0.85rem', opacity: 0.9 }}>Angemeldet als: <strong>{userInfo.email}</strong></span>
              <button 
                onClick={handleLogout} 
                className="btn-secondary-action" 
                style={{ padding: '0.4rem 0.8rem', fontSize: '0.85rem', margin: 0, border: '1px solid #fff' }}
              >
                Logout
              </button>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;